<template>
  <div class="ma-4">
   <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
   <StaffNav/>
   <v-row dense>
    <v-col cols="12" lg="3" xl="2">
      <StaffSide />
    </v-col>
    <v-col cols="12" lg="9" xl="10">
      <v-card class="pa-2" outlined tile height="100%">
    <v-data-table
      :headers="headers"
      :items="logs"
      sort-by="Date"
      sort-desc
      :loading="isLoading"
      loading-text="Loading Communication Logs"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Communication Logs</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="search"
            label="search"
            class="desktop"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="100%">
            <template v-slot:activator="{ on }">
              <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()"
                >
                <v-icon left>add</v-icon>
                Add Log</v-btn
              >
            </template>
            <v-card>
              <v-card-title style="background-color: #2b3990">
                <span class="headline white--text">{{ titleForm  }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="4">
                        <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="true"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="newDate"
                            label="Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="newDate"
                        no-title
                        scrollable
                        >
                        <!-- <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="menu = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(date)"
                        >
                            OK
                        </v-btn> -->
                        </v-date-picker>
                    </v-menu>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                        <v-text-field
                            prepend-icon="schedule"
                            label="Time"
                            v-model="time"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                      <v-text-field
                        label="Who Contacted"
                        v-model="contacted"
                    ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        label="Specify"
                        v-model="specify"
                    ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        label="Note Type"
                        :items="notes"
                        v-model="noteType"
                    ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-textarea
                        label="Communication Notes"
                        v-model="communicationNotes"
                        outlined
                    ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        :items="commType"
                        v-model="communicationType"
                        label="Communications Type"
                    ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="createdBy"
                        label="Created By"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-file-input   
                          v-model="newDocument"                             
                          class="pa-2"
                          label="Select documents to upload"
                          show-size
                          filled
                          multiple
                          prepend-icon="mdi-camera"
                          accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          @change="fileSelected"
                        
                        >
                          <template #selection="{ text, index }">
                            <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                          </template>
                        </v-file-input>
                      </v-col>

                     
                        
                      
                      <v-col cols="12" sm="12" md="3" 
                          v-for="document in newDocument" :key="document.url"
                        >
                        
                        <template v-if="document.type === 'pdf'">
                          <LoadPDF :pdfFile="document.url" :pdfName="document.name"/>
                        </template>
                        <template v-else-if="['jpg', 'jpeg', 'png', 'JPG', 'PNG', 'JPEG'].includes(document.type)">
                          <v-img max-height="320" max-width="240" :src="document.url" />
                        </template>
                      
                      </v-col>

                      <v-col cols="12" sm="12">
                        <v-file-input
                            chips
                            show-size
                            class="pa-2"
                            label="Select videos to upload"
                            filled
                            multiple
                            prepend-icon="mdi-play-circle-outline"
                            accept="video/mp4,video/x-m4v,video/*"
                            @change="selectCommunicationLogVideos"
                        ></v-file-input>
                      </v-col>

                      <v-col cols="12" sm="12">
                        <div
                            v-for="communicationLogVideoUrl in selectedCommunicationLog.CommunicationLogVideos"
                            :key="communicationLogVideoUrl"
                        >
                            <video width="320" height="240" controls>
                                <source :src="communicationLogVideoUrl" type="video/mp4">
                                <source :src="communicationLogVideoUrl" type="video/ogg">
                                Your browser does not support the
                                tag.
                            </video>
                        </div>
                      </v-col>

                      <v-col cols="12" sm="12">
                        <v-file-input
                            chips
                            show-size
                            class="pa-2"
                            label="Select audio to upload"
                            filled
                            prepend-icon="mic"
                            accept="audio/*"
                            v-model="showAudioFile"
                            @change="handleFileChange($event)"
                        ></v-file-input>
                      </v-col>

                      <v-col cols="12" v-if="showAudioFile">
                        <audio ref="audioPlayer" controls>
                        <source :src="showAudioFile" type="audio/mpeg">
                        Your browser does not support the audio element.
                      </audio>
                      </v-col>
                      
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#259647" class="white--text" @click="addCommunication()" v-if="newLog">Save</v-btn
                >
                <v-btn color="blue darken-1" text @click="updateCommunication()" v-if="editLog">Update</v-btn
                >
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-text-field
          v-model="search"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          label="search"
          class="mobile ml-5 mr-5 mb-3 mt-3"
        ></v-text-field>
      </template>

     <template v-slot:item.actions="{ item }">
        <span v-if="item.documents != null">
            <v-icon small class="mr-2" @click="downloadDocument(item)">
                mdi-download
            </v-icon>
        </span>

        <v-icon small class="mr-2" @click="viewCommunication(item)">
          mdi-eye
        </v-icon>
        
        <v-icon small @click="deleteCommunication(item)" v-if="admin">
          mdi-delete
        </v-icon>
        
      </template>
      <template v-slot:no-data>
        <v-btn color="#2b3990" class="white--text" @click="getCommunications()">Reset</v-btn>
      </template>
    </v-data-table>
      </v-card>
    </v-col>
    </v-row>
    <Foot/>
  </div>
</template>

<script>
import axios from 'axios'
import StaffNav from '@/components/StaffNav'
import StaffSide from '@/components/StaffSide'
import Foot from '@/components/Footer'
import LoadPDF from '@/components/LoadPDF.vue'
// import moment from 'moment'

const url = require("../client_config/config").url;

export default {
  components: {
      StaffNav,
      StaffSide,
      Foot,
      LoadPDF
  },
  data: function() {
    return {
      headers: [
        {
          text: 'Date',
          align: 'start',
          sortable: false,
          value: 'Date',
        },
        { text: "Time", value: "Time" },
        { text: "Note Type", value: "NoteType" },
        { text: "Notes", value: "Notes" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      admin: false,
      dialog: false,
      editLog: false,
      newLog: false,
      msg: false,
      menu: false,
      signed: false,
      search: "",
      text:"",
      logs: [],
      isLoading: false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      notes: ["Admissions",
        "AMA",
        "Clinical Team Meeting",
        "Dietitian",
        "Discharge",
        "Education",
        "Family Therapy",
        "General",
        "Group Therapy",
        "Nursing",
        "Phase Coordinator",
        "Progress",
        "Recreational Therapy",
        "Relapse",
        "Residential Advisor",
        "Services",
        "Staff Shift Change",
        "Utilization Review",
        "Warnings",
        "Other"],
      commType: ["Family",
        "Legal",
        "Referent",
        "Other"],
      newDate: "",
      time: "",
      contacted: "",
      specify: "",
      noteType: "",
      communicationNotes: "",
      communicationType: "",
      createdBy: localStorage.getItem('Name'),
      staffID: "",
      communicationID: "",
      titleForm: "",
      newDocument: [],
      uploadFile: "",
      newCommunicationLogVideo: "",
      communicationLogVideos: [],
      selectedCommunicationLog: {},
      wavesurfer: null,
      selectedFile: null,
      showAudioFile: "",
      
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.staffID = this.$route.params.employeeID
    this.getCommunications();
    if(localStorage.getItem('userRole') == 'Administration'){
        this.admin = true;
    }
  },

  methods: {
     viewCommunication(item) {
        this.titleForm= "Viewing Communication Log";
        this.dialog = true;
        this.editLog = true;
        this.newLog = false;
        this.newDate = item.Date;
        this.time = item.Time;
        this.contacted = item.Contacted;
        this.specify = item.Specify;
        this.noteType = item.NoteType;
        this.communicationNotes = item.Notes;
        this.communicationType = item.CommType;
        this.createdBy = item.CreatedBy;
        this.newCommunicationLogVideo = item.CommunicationLogVideo;
        this.communicationID = item._id;

        // if(item.documents.length > 0){
        // const tempData = [];
        // for(let i = 0; i < item.documents.length ; i++){
        //   tempData.push({
        //     name: item.documents[i].Name,
        //     awsLink: item.documents[i].AWSLink,
        //   });
        //   }
        //   this.newDocument = tempData;
        // }
        this.selectedCommunicationLog = item;
        this.selectedCommunicationLog.CommunicationLogVideos = item.CommunicationLogVideo ? item?.CommunicationLogVideo?.split(',') : [];
        this.showAudioFile = item.CommunicationAudio
        let documents = [];

            if (item.documents) {
                documents = item.documents && item.documents.length ? item.documents : [item.documents];
            }

            if (documents) {
                this.newDocument = documents.map(document => {
                    return {
                        name: document.Name,
                        url: document.AWSLink,
                        type: document?.AWSLink?.split('.').pop()
                    };
                });
            }
        },
        showAdd() {
        this.titleForm= "New Communication Log";
        this.createdBy = localStorage.getItem('Name');
        this.newLog = true;
        this.editLog  = false;
        },

        deleteCommunication(item) {
        const id = item._id;
        confirm("Are you sure you want to delete this communication log?") &&
        this.communicationDelete(id);

        },

        communicationDelete(id) {
        axios.delete(`${url}/staffCommunications/${id}`)
        .then((response) => {
            this.getCommunications();
            if (response.status == 400) {
            response.json().then(function(data) {
                return data.msg;
            });
            }
            this.msg=true;
            this.text="The communication log has been deleted successfully.";
        });
        },

        close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
        this.clearData()
        },

        updateCommunication() {
        var req_body = {
            Date: this.newDate,
            Time: this.time,
            Contacted: this.contacted,
            Specify: this.specify,
            NoteType: this.noteType,
            Notes: this.communicationNotes,
            Commtype: this.communicationType,
            CommunicationLogVideo: this.newCommunicationLogVideo,
        };
        axios.put(`${url}/staffCommunications/${this.communicationID}`, req_body).then(async(response) => {
            this.getCommunications();
            if (response.status == 400) {
            response.json().then(function(data) {
                alert(data.msg);
            });
            }
            this.msg =true;
            this.text ="The communication log has been updated successfully.";
             if(this.uploadFile !== null && this.uploadFile !== undefined){
                this.saveFile()
             }
             if (this.communicationLogVideos && this.communicationLogVideos.length) {
                await this.uploadCommunicationLogVideos(this.communicationLogVideos);
            }
            if (this.selectedFile) {
                await this.uploadAudio()
            }
        });
        this.close();
        },
        getCommunications: function() {
        this.isLoading = true;
        axios.get(`${url}/staffCommunications/${this.staffID}`).then(res => {
            this.logs = res.data.communication;
        }).finally(() => this.isLoading = false);
        },

        addCommunication: function() {
        this.createdBy = localStorage.getItem('Name');

        var req_body = {
            Date: this.newDate,
            Time: this.time,
            Contacted: this.contacted,
            Specify: this.specify,
            NoteType: this.noteType,
            Notes: this.communicationNotes,
            CommType: this.communicationType,
            CreatedBy: this.createdBy,
            CommunicationLogVideo: this.newCommunicationLogVideo,
            StaffID: this.staffID,
        };

        axios.post(`${url}/staffCommunications`, req_body ).then(async(res) => {
            this.getCommunications();
            if (res.status == 400) {
            res.json().then(function(data) {
                this.text=data.msg;
            });
            }
            this.msg =true;
            this.text ="The new communication log has been added successfully.";
            if(this.uploadFile !== null && this.uploadFile !== undefined){
              this.communicationID = res.data._id

              this.saveFile()
            }
            if (this.communicationLogVideos && this.communicationLogVideos.length) {
                await this.uploadCommunicationLogVideos(this.communicationLogVideos);
            }
            if (this.selectedFile) {
                await this.uploadAudio()
            }
            });
          this.close();
        },

        clearData() {
          this.newDate= "";
          this.time = "";
          this.contacted = "";
          this.specify = "";
          this.noteType = "";
          this.communicationNotes = "";
          this.communicationType = "";
          this.createdBy = "";
          this.newDocument = [];
          this.newIncidentVideo = "";
          this.showAudioFile = "";
          this.selectedCommunicationLog = {}
        },

        fileSelected(e) {
          this.uploadFile=e;
        },

        saveFile() {
          this.message = "";
          for (let i = 0; i < this.uploadFile.length; i++) {
            this.uploadFiles(this.uploadFile[i]);
          }
        },

        uploadFiles(file) {
          const formData = new FormData();
          formData.append('communicationLogs', file);
          var ct = { headers:{"content-type" : "multipart/form-data"}};
          axios.post(`${url}/staffCommunications/fileuploader/${this.communicationID}`,formData, ct)
          .then(res => {
            if(res){
              this.getCommunications();
            }
          })
          .catch(err => {
            console.log(err);
          });
        },

        deleteChip(index) {
          // Prompt here with text if required
          this.newDocument.splice(index, 1);
        },
        downloadDocument(item) {
          if (item.documents && item.documents.length > 0) {
            for (let i = 0; i < item.documents.length; i++) {
              let document = item.documents[i];
              let documentName = document.Name || '';
              let documentLink = document.AWSLink || '';
              let FileSaver = require('file-saver');
              FileSaver.saveAs(documentLink, documentName);
            }
          }
        },
        selectCommunicationLogVideos(communicationLogVideos) {
            this.communicationLogVideos = communicationLogVideos;
        },

        async uploadCommunicationLogVideos(files) {
            const formData = new FormData();
            formData.append('communicationId', this.communicationID);

            for (let file of files) {
                formData.append('communicationLogVideos[]', file);
            }

            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };

            try {
                await axios.post(`${url}/staffCommunications/video/upload`, formData, config);
            } catch (e) {
                console.log({e});
            }
        },

        handleFileChange(file) {
          this.selectedFile = file
          console.log(this.selectedFile, "selectedFile");
        },

        async uploadAudio() {
          if (!this.selectedFile) {
            alert('Please select an audio file to upload.');
            return;
          }

          
          const formData = new FormData();
          formData.append('audio', this.selectedFile);

          formData.append('communicationId', this.communicationID);

          try {
            
            const response = await axios.post(`${url}/staffCommunications/audio/file/upload`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            });
            console.log(response.data);
            // alert('Audio uploaded successfully');
          } catch (error) {
            console.error(error);
            alert('Error uploading audio');
          }
        },
  },

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }
</style>